<script setup lang="ts">
import { computed, ref } from 'vue'
import type { SurveyStep } from '@/types/surveyTypes'
import StepperItemQuestion from './StepperItemQuestion.vue'
import { Form } from 'vee-validate'
import { useSurvey } from '@/composables/onlineSurvey/useSurvey'

const {
  currentStep,
  stepsCount,
  goToStep,
  createStepValidationSchema,
  getCurrentStepAnswers,
  answers,
} = useSurvey()
const formRef = ref()

const props = defineProps<{
  step: SurveyStep
}>()

//emit event when survey is completed
const emit = defineEmits<{
  (e: 'surveryCompleted', stepIndex: number): void
}>()

const validationSchema = computed(() => {
  answers.value
  return createStepValidationSchema(currentStep.value)
})

const initialValues = computed(() => {
  answers.value
  return getCurrentStepAnswers()
})

const handleSubmit = async () => {
  if (!formRef.value) return

  const { valid } = await formRef.value.validate()
  console.log(valid)
  if (valid) {
    moveStep(1)
  }
}

function moveStep(direction: number) {
  console.log('Moving step:', direction)
  const nextStep = currentStep.value + direction
  if (nextStep < 0 || nextStep > stepsCount.value) return
  if (nextStep == stepsCount.value) {
    //FORM FINISHED
    emit('surveryCompleted', currentStep.value)
    return
  }
  goToStep(nextStep)
}

const backwardDisabled = computed(() => {
  return currentStep.value <= 0
})
</script>
<template>
  <div class="stepper-item">
    <Form
      ref="formRef"
      :validation-schema="validationSchema"
      :initial-values="initialValues"
      @submit="handleSubmit"
      v-slot="{ isSubmitting }"
    >
      <h2 class="is-size-5 has-text-weight-semibold">
        {{ props.step.title }}
      </h2>
      <div v-for="question in props.step.questions" :key="question.id">
        <StepperItemQuestion :question="question" />
      </div>

      <div class="is-flex is-justify-content-space-between mt-2">
        <button
          type="button"
          class="button is-light is-small"
          @click="moveStep(-1)"
          :disabled="backwardDisabled"
        >
          Zurück
        </button>
        <button
          type="submit"
          class="button is-primary is-small"
          :class="{ 'is-loading': isSubmitting }"
        >
          Weiter
        </button>
      </div>
    </Form>
  </div>
</template>
